var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_54266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80474 7.33301H16.1988C16.4632 7.33298 16.7244 7.39011 16.9646 7.50048C17.2048 7.61086 17.4182 7.77187 17.5904 7.97248C17.7625 8.17308 17.8892 8.40854 17.9618 8.66271C18.0345 8.91688 18.0513 9.18374 18.0111 9.44501L16.8607 16.9177C16.7608 17.5671 16.4317 18.1593 15.933 18.587C15.4343 19.0148 14.7989 19.2499 14.1418 19.2497H7.86083C7.20394 19.2496 6.56877 19.0145 6.07024 18.5867C5.57171 18.159 5.24276 17.5669 5.14291 16.9177L3.99249 9.44501C3.95231 9.18374 3.96911 8.91688 4.04172 8.66271C4.11434 8.40854 4.24106 8.17308 4.41319 7.97248C4.58533 7.77187 4.79881 7.61086 5.039 7.50048C5.27919 7.39011 5.54041 7.33298 5.80474 7.33301Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.0833V5.5C8.25 4.77065 8.53973 4.07118 9.05546 3.55546C9.57118 3.03973 10.2707 2.75 11 2.75C11.7293 2.75 12.4288 3.03973 12.9445 3.55546C13.4603 4.07118 13.75 4.77065 13.75 5.5V10.0833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_54266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseIcon);
export default __webpack_public_path__ + "static/media/PurchaseIcon.3305bab41bbd2422cf0ad4803340bd2a.svg";
export { ForwardRef as ReactComponent };